import { render } from "./Menu.vue?vue&type=template&id=2add28ef&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=2add28ef&lang=css"
import "./Menu.vue?vue&type=style&index=1&id=2add28ef&lang=scss&scoped=true"

import exportComponent from "/Users/documedias/gitlab/virtuell/ispad2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2add28ef"]])

export default __exports__